import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useMutation } from '..';

interface UseInviteDeclineProps {
  collaborationId: string;
  onSuccess: TypeAny;
  reason: string;
}

export function useInviteDecline({ collaborationId, onSuccess, reason }: UseInviteDeclineProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { isLoading, mutate, error, data } = useMutation({
    mutationKey: `influencer-invite-decline-${collaborationId}`,
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/invite/${collaborationId}/decline`,
        body: { reason },
        token
      }).then((response: ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    data: data || {},
    isLoading,
    mutate,
    error
  };
}
